import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { generalService } from '../../services/general.service';
import { ItemGrid } from '../../models/item';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { MatOptionSelectionChange, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import { ProductAddEditComponent } from '../../product/add-edit/product-add-edit.component';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import { MatSelect } from '@angular/material/select';
import { EditCodeSatService } from '../../services/edit-code-sat.service';
import { FacturaUnidadMedida } from '../../models/facturaUnidadMedida';
import { EditUnitSatService } from '../../services/edit-unit-sat.service';

@Component({
  selector: 'my-product-consult-delete',
  templateUrl: './product-consult-delete.component.html',
  styleUrls: [],
  providers: [generalService,  EditCodeSatService,EditUnitSatService]
})
export class ProductConsultDeleteComponent implements OnInit {

   /***************************INFINITE SELECT**********************************/
  public viewDataProduct: any[];
  @ViewChild('infiniteSelect') selectElem: MatSelect;
  private itemsShow = 10;
  private filteredItemsShowSat = 10;
  private arrayFilteredSat = undefined;
  private isFilteredSat = false;
  /***************************INFINITE SELECT**********************************/

  public title = 'Producto';
  public getInactives = false;
  public disabledCheck = true;

  public dataSource: DataSourceGrid | null;
  public displayedColumns = ['acciones', 'SKU', 'barcode', 'name', 'itemSat','unitSAT', 'purchase', 'sale'];
  public productList: Array<ItemGrid>;
  public numberOfRecords = 0;
  public preciosEdit: boolean;

  public datosGeneralesSAE: any;
  public palabraFiltro = null;

  private loacs;
  public matOptions: any;
  public filtroSATCodes: any[];

  // Modal messages
  private readonly CONFIRM_DELETE_MSG = '¿Está seguro que desea eliminar el producto?';
  private readonly DELETE_SUCCESS_MSG = 'Producto eliminado exitosamente';
  private readonly REACTIVATE_SUCCESS_MSG = 'Producto reactivado exitosamente';

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  constructor(private _generalService: generalService,
              public dataService: DataService,
              public dialog: MatDialog,
              private cdr: ChangeDetectorRef,
              private _editCodeSatService : EditCodeSatService,
              private _editUnitSatService : EditUnitSatService  
              )
              
              {
                this.datosGeneralesSAE = DatosGeneralesSAE;
                this._editCodeSatService.consultSATcode();
                this._editUnitSatService.consultSATunit();
                this.buildMatOptionsList();
                
               }

 async ngOnInit() {
    this.preciosEdit = false;
    this.datosGeneralesSAE.showSpinnerLoading = true;
    this.loacs = sessionStorage.getItem("acslo");
    await this.consultSATunit();
    this.consultProducts();
    if (this.dataService.palabraFiltro != '') {
    this.palabraFiltro = this.dataService.palabraFiltro;
    }
    //this.buildMatOptionsList();
    //this.selectElem.onOpen.subscribe(() => this.registerPanelScrollEvent());
  }

  buildMatOptionsList() {
    this.matOptions = new Object();
    this.matOptions.SATcodes = [];
  }

  confirmDeleteProduct(product: ItemGrid) {
    this.dataService.modal = 'confirm';
    this.dataService.mensaje = this.CONFIRM_DELETE_MSG;

    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogRef = dialogModal;

    dialogModal.afterClosed()
               .subscribe(result => {
                 if (this.dataService.guardado) {
                  this.deleteProduct(product.itemId);
                 }
               });
  }

  deleteProduct(productId: number) {
    this._generalService.metodoCallParams(this.loacs, `item/disable?itemId=${productId}`)
        .subscribe(ok => {
          this._generalService.toastCall(this.DELETE_SUCCESS_MSG);
          this.productList = this.productList.filter(item => item.itemId !== productId);

          if (this.productList.length > 0) {
            this.dataSource = new DataSourceGrid(this.productList, this.paginator, this.sort);
          } else {
            this.dataSource = undefined;
          }

        }, error => {
          // Custom error handler
        });
  }

  consultProducts() {
    this.consult();
  }

  consultDisabledItems() {
    this.consult(true);
  }

  consult(disabledProducts=false) {
    this._generalService.metodoCallParams(this.loacs, `item/${disabledProducts? 'consultDisabledItems' : 'consultItems'}`)
        .finally(() => this.disabledCheck = false)
        .subscribe(products => {
          this.productList = JSON.parse(products);
          this.numberOfRecords = this.productList.length;

          if (this.productList.length > 0) {
            this.dataSource = new DataSourceGrid(this.productList, this.paginator, this.sort);
            if (this.dataService.palabraFiltro != null) {
              this.searchFilter(this.dataService.palabraFiltro);
            }
            //this.consultSATcode();
          } else {
            this.dataSource = undefined;
          }
          this.datosGeneralesSAE.showSpinnerLoading = false;
        }, error => {
          // Custom error handler
        });

    
  }

  consultSATcode(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall('itemCodeSAT/consultItemSATcodes')
          .subscribe(SATcodes => {
            SATcodes = JSON.parse(SATcodes);
            this.matOptions.SATcodes = SATcodes;
            this.filtroSATCodes = this.matOptions.SATcodes;

            /***************************INFINITE SELECT**********************************/
            this.viewDataProduct = this.matOptions.SATcodes.slice(0, 10);
            /***************************INFINITE SELECT**********************************/

            this.moverSeleccion();

            resolve();
          }, error => {
            // Custom error handler
            reject();
          });
    });
  }

  moverSeleccion() {
    /***************************INFINITE SELECT**********************************/
    const index = 1;//this.matOptions.SATcodes.findIndex(x => x.itemSATcodeId == this.product.itemSATcode);
    var a = this.matOptions.SATcodes.splice(index,1);
    this.matOptions.SATcodes.unshift(a[0]);
    
    this.viewDataProduct = this.matOptions.SATcodes.slice(0, 10);
    /***************************INFINITE SELECT**********************************/
  }


  checkChange() {
    this.disabledCheck = true;
    this.cdr.detectChanges();
    if (this.getInactives) {
      this.consultDisabledItems();
    } else {
      this.consultProducts();
    }
  }

  reactivateProduct(product: ItemGrid) {
    this._generalService.metodoCallParams(this.loacs, `item/enable?itemId=${product.itemId}`)
    .subscribe(ok => {
      this._generalService.toastCall(this.REACTIVATE_SUCCESS_MSG);
      this.productList = this.productList.filter(item => item.itemId !== product.itemId);
      
      if (this.productList.length > 0) {
        this.dataSource = new DataSourceGrid(this.productList, this.paginator, this.sort);
      } else {
        this.dataSource = undefined;
      }

    }, error => {
      // Custom error handler
    });
  }

  searchFilter(searchTerm: string) {
      this.dataService.palabraFiltro = searchTerm;
      if(this.productList.length <= 0) {
        this.dataSource = undefined;  } 
      else {
        let filteredProducts = this.productList;
        if(searchTerm != "") {
          filteredProducts = this.productList.slice().filter((item: ItemGrid) => {            
            if (item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 ||
                item.familyName.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 ||
                item.subFamilyName.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 ||
                item.SKU.toString().toLowerCase().indexOf(searchTerm.toLowerCase()) != -1)
              return true;
            else
              return false;
          });
        }

        for (let i = 0; i < filteredProducts.length; i++) {
          if (!filteredProducts[i].name.toLowerCase().includes(searchTerm.toLowerCase()) &&
              !filteredProducts[i].familyName.toLowerCase().includes(searchTerm.toLowerCase()) &&
              !filteredProducts[i].subFamilyName.toLowerCase().includes(searchTerm.toLowerCase()) &&
              !filteredProducts[i].SKU.toString().toLowerCase().startsWith(searchTerm.toLowerCase())) {
            filteredProducts.splice(i, 1);
            i = i-1;
          }
        }
        
        this.dataSource = new DataSourceGrid(filteredProducts, this.paginator, this.sort);
        this.numberOfRecords = filteredProducts.length;
      }
  }

  async mostrarModalAgregarProducto(productId) {
    const productoSeleccionado = await this.consultarProducto(productId);        
    const modalAgregarProducto = this.dialog.open(ProductAddEditComponent, {
        height: '80%',
        data: {producto: productoSeleccionado},
     });

    modalAgregarProducto.afterClosed().subscribe((producto) => {
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this.consultProducts();
    });
  }

  consultarProducto(productId: number): Promise<any> {
    return new Promise((resolve, reject) =>  {
        this._generalService.metodoCall(`item/consultItem?itemId=${productId}`, true)
            .subscribe(item => {
                item = JSON.parse(item);
                if (item.length > 0) {
                    resolve(item[0]);
                }
                resolve(null);
            }, error => {
                resolve(null);
              // Custom error handler
            });    
    });
  }

  habilitarEdicion(){
    this.preciosEdit = !this.preciosEdit;
  }

  inputCambioPrecio(e: any, valor: any, decimales: number, tipoInput: boolean, idProducto: number){
    this.inputNumerosConDecimales(e, valor, decimales);
    if(e.keyCode == 13){
      if (valor != null) {
        if(valor > 0) {
          this.datosGeneralesSAE.showSpinnerLoading = true;
          let tipo = 'agregar';
          let link = 'item/inputCambioPrecio/';
          let cambioPrecio = {
            idItem: idProducto,
            nuevoPrecio: valor,
            tipoPrecio: tipoInput
          };

          this._generalService.metodoCallParamsPutPost(tipo, cambioPrecio, link).subscribe( 
            (result) => {
              if (result != '') {
                this._generalService.toastCall(result.message);
                this.datosGeneralesSAE.showSpinnerLoading = false; } 
              else {
                this._generalService.toastCall("Precios actualizados.");
                this.consultProducts(); }
            },
            (error) => {
              const errorMsj =  error as any;
              console.log(errorMsj); 
            }); 
        } else {
          this._generalService.toastCall("Valores nulos o negativos no aceptables.");
        }
      } else {
        this._generalService.toastCall("El campo del precio está vacío.");
      }
    }
  }

  inputCambioTexto(e: any, valor: any, tipoInput: boolean, idProducto: number){
    if(e.keyCode == 13){
      if (valor != null) {
        if(valor > 0) {
          this.datosGeneralesSAE.showSpinnerLoading = true;
          let tipo = 'agregar';
          let link = 'item/inputCambioPrecio/';
          let cambioPrecio = {
            idItem: idProducto,
            nuevoPrecio: valor,
            tipoPrecio: tipoInput
          };

          this._generalService.metodoCallParamsPutPost(tipo, cambioPrecio, link).subscribe( 
            (result) => {
              if (result != '') {
                this._generalService.toastCall(result.message);
                this.datosGeneralesSAE.showSpinnerLoading = false; } 
              else {
                this._generalService.toastCall("Precios actualizados.");
                this.consultProducts(); }
            },
            (error) => {
              const errorMsj =  error as any;
              console.log(errorMsj); 
            }); 
        } else {
          this._generalService.toastCall("Valores nulos o negativos no aceptables.");
        }
      } else {
        this._generalService.toastCall("El campo del precio está vacío.");
      }
    }
  }

  cambioTexto(valor: any, tipoInput: boolean, idProducto: number, companyId : number){
    if (valor != null) {
          this.datosGeneralesSAE.showSpinnerLoading = true;
          let tipo = 'agregar';
          let link = 'item/inputCambioTexto/';
          let cambioTexto = {
            idItem: idProducto,
            nuevoTexto: valor,
            tipoTexto: tipoInput,
            idCompany: companyId, 
            loacs2: this.loacs
          };

          this._generalService.metodoCallParamsPutPost(tipo, cambioTexto, link).subscribe( 
            (result) => {
              if (result != 1) {
                this._generalService.toastCall(result);    
                this.consultProducts();
              } 
              else
              {
                this.datosGeneralesSAE.showSpinnerLoading = false; 
              }
            },
            (error) => {
              const errorMsj =  error as any;
              console.log(errorMsj); 
            }); 
      } else {
        this._generalService.toastCall("El campo está vacío.");
      }
  }


  cambioPrecio(valor: any, tipoInput: boolean, idProducto: number){
    if (valor != null) {
        if(valor > 0) {
          this.datosGeneralesSAE.showSpinnerLoading = true;
          let tipo = 'agregar';
          let link = 'item/inputCambioPrecio/';
          let cambioPrecio = {
            idItem: idProducto,
            nuevoPrecio: valor,
            tipoPrecio: tipoInput
          };

          this._generalService.metodoCallParamsPutPost(tipo, cambioPrecio, link).subscribe( 
            (result) => {
              if (result != '') {
                this._generalService.toastCall(result.message);
                this.datosGeneralesSAE.showSpinnerLoading = false; } 
              else {
                this.consultProducts(); }
            },
            (error) => {
              const errorMsj =  error as any;
              console.log(errorMsj); 
            }); 
        } else {
          this._generalService.toastCall("Valores nulos o negativos no aceptables.");
        }
      } else {
        this._generalService.toastCall("El campo del precio está vacío.");
      }
  }

  onKeyUpSATcode(val: any) {
    let arr: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredSat = this.filtroSATCodes.filter((obj) => {
        return (obj.SATcode.includes(val.currentTarget.value) > 0 || obj.DESCRIPTION.toLowerCase().includes(val.currentTarget.value.toLowerCase()));
      })

      arr = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
      this.isFilteredSat = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredSat = false;
      this.filteredItemsShowSat = 10;
      this.arrayFilteredSat = undefined;
      arr = this.matOptions.SATcodes.slice(0, this.itemsShow);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    //this.matOptions.SATcodes = arr;
    this.viewDataProduct = arr;
    /***************************INFINITE SELECT**********************************/
  }

  registerPanelScrollEvent() {
    const panel = this.selectElem.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
      if(this.isFilteredSat) {
        if(this.filteredItemsShowSat < this.arrayFilteredSat.length) {
            this.filteredItemsShowSat += 10;
            this.viewDataProduct = this.arrayFilteredSat.slice(0, this.filteredItemsShowSat);
        }
      } else {
        if(this.itemsShow < this.matOptions.SATcodes.length) {
          this.itemsShow += 10;
          this.viewDataProduct = this.matOptions.SATcodes.slice(0, this.itemsShow);
        }
      }
    }
  }
  /***************************INFINITE SELECT**********************************/


  hasDecimalPlace(value: any, decimales: any) {
    // Verifica que solo cuente con las decimales que se establecio en el input
    const ed = value.split(".");
    if(ed.length > 1){
        return ed[1].length > 2;
    }
    else{
        return false;
    }
  }

  inputNumerosConDecimales(e: any, valor: any, decimales: number): boolean {
      // Verifica que la tecla ingresada fuera copiar, pegar, eliminar, numeros o puntos decimales
      if ([8, 9, 13, 27, 46, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) || 
          (e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) || 
          (e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) || 
          (e.keyCode === 88 && e.ctrlKey === true)) {

          const character = String.fromCharCode(e.keyCode);
          valor = (valor) ? valor : '';
          const newValue: any = valor + character;
          // Verifica que no tenga más de un punto y que solo cuente con las decimales que se establecio en el input
          if (isNaN(newValue) || this.hasDecimalPlace(newValue, decimales)) {
              e.preventDefault();
              return false;
          }
          else{
              return;
          }
      }
      else{
          e.preventDefault();
          return false;
      }
  }

  onPaste(e: any) {
    e.preventDefault();
  }

  changeCode(code:any[]){
   this.cambioSATCode(code[0],code[1]);
  }
  cambioSATCode(idItem:number,idSATCode:number){

          this.datosGeneralesSAE.showSpinnerLoading = true;
          let tipo = 'actualizar';
          let link = 'item/inputCambioSATCode/';
          let InputCambioSATCodeModel = {
            idItem: idItem,
            idSATCode: idSATCode
          };

          this._generalService.metodoCallParamsPutPost(tipo, InputCambioSATCodeModel, link).subscribe( 
            (result) => {
              if (result != 'ok') {
                this._generalService.toastCall(result);
                this.datosGeneralesSAE.showSpinnerLoading = false; } 
              else {
               this.consultProducts();
               this._generalService.toastCall("Código SAT cambiado correctamente"); 
               this.datosGeneralesSAE.showSpinnerLoading = false; 
              }
            },
            (error) => {
              const errorMsj =  error as any;
              console.log(errorMsj); 
            }); 
       
      
  }

  changeUnitSAT(code:any[]){
    this.cambioUnitSAT(code[0],code[1]);
   }
   cambioUnitSAT(idItem:number,idUnitSat:number){
 
           this.datosGeneralesSAE.showSpinnerLoading = true;
           let tipo = 'actualizar';
           let link = 'item/inputCambioUnitSat/';
           let InputCambioUnitSATCodeModel = {
             idItem: idItem,
             nuevoUnitSAT: idUnitSat
           };
 
           this._generalService.metodoCallParamsPutPost(tipo, InputCambioUnitSATCodeModel, link).subscribe( 
             (result) => {
               if (result != 'ok') {
                 this._generalService.toastCall(result);
                 this.datosGeneralesSAE.showSpinnerLoading = false; } 
               else {
                this.consultProducts();
                this._generalService.toastCall("Unidad SAT cambiado correctamente"); 
                this.datosGeneralesSAE.showSpinnerLoading = false; 
               }
             },
             (error) => {
               const errorMsj =  error as any;
               console.log(errorMsj); 
             }); 
        
       
   }

  consultarUnidadMedidaSAT(){

    this._generalService.metodoCall("").subscribe( 
      (result) => {
        if (result != 'ok') {
          this._generalService.toastCall(result);
          this.datosGeneralesSAE.showSpinnerLoading = false; } 
        else {
         this.consultProducts();
         this._generalService.toastCall("Código SAT cambiado correctamente"); 
         this.datosGeneralesSAE.showSpinnerLoading = false; 
        }
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj); 
      }); 
 

}

consultSATunit(): Promise<void> {
  return new Promise((resolve, reject) => {
    this._generalService.metodoCall('itemCodeSAT/consultItemSATunits')
        .subscribe(SATunits => {
          SATunits = JSON.parse(SATunits);
          this.matOptions.SATunits = SATunits;
          //this.filtroSATUnits = this.matOptions.SATunits;

          /***************************INFINITE SELECT**********************************/
          //this.viewDataProduct2 = this.matOptions.SATunits.slice(0, 10);
          /***************************INFINITE SELECT**********************************/

          resolve();
        }, error => {
          // Custom error handler
          reject();
        });
  });
}

moverSeleccionSATUnit(proudct:any) {
  /***************************INFINITE SELECT**********************************/
  const index = this.matOptions.SATunits.findIndex(x => x.itemSATUnitId == proudct.itemSATUnitId);
  var a = this.matOptions.SATunits.splice(index,1);
  this.matOptions.SATunits.unshift(a[0]);
  
  proudct.SATunits = this.matOptions.SATunits.slice(0, 10);
  /***************************INFINITE SELECT**********************************/
}

}



// WEBPACK FOOTER //
// ./src/app/product/consult-delete/product-consult-delete.component.ts